<template>
  <div>
    <div class="row">
      <div class="col-6">
      </div>
      <div class="col-6" v-bind:style="{ width:'100%', textAlign: 'right', paddingRight:'20px' }">
        <i class=" mr-1 bi bi-sliders" data-toogle="tooltip" title="Settings" v-b-modal="componentId+'-modal'"
           v-bind:style="{ fontSize : '15px'}"></i>
        <i class=" mr-1 bi bi-card-text" data-toogle="tooltip" title="Legend" v-bind:style="{fontSize : '15px'}" v-b-modal="componentId+'-legend'"></i>
        <i class="mr-1 bi bi-save-fill" data-toogle="tooltip" title="Export" v-bind:style="{ fontSize : '12px'}"
           v-b-modal="componentId+'-modal-save'"></i>
        <i class=" mr-1 bi bi-files" data-toogle="tooltip" title="Duplicate" v-on:click="cloneCurrentWidget"
           v-bind:style="{ fontSize : '12px'}"></i>
      </div>
    </div>
    <div class="widget-legend legend">
      <span>{{ this.dataTypeText }} by {{ this.sublevel }} of
        {{ this.searchPanelTaxon }} on fraction {{ this.fraction }} µm</span>
    </div>
    <NormalizedBarChartWidget :plotData="plotData" :componentId="componentId" :barnumber="barnumber" :page="page"
                              :advanced="advanced">
    </NormalizedBarChartWidget>
    <b-modal :id="componentId+'-modal'" title="Relative taxonomic composition">
      <div class="form-group mt-2" style="font-size: 1.6vmin;">
        <div class="form-group mt-2">
          <template>
            <b-form-group label="Representation" v-slot="{ ariaDescribedby }">
              <b-form-radio-group
                  :id="componentId+'radio-group-1'"
                  v-model="dataType"
                  :options="dataTypes"
                  :aria-describedby="ariaDescribedby"
                  name="dataTypes-options"
              ></b-form-radio-group>
            </b-form-group>
          </template>
        </div>
        <b-form-group label="Grouped by">
          <select v-model="groupType" class="form-control">
            <option v-for="option in groupTypes" v-bind:key="option.value" :value="option.value">
              {{ option.text }}
            </option>
          </select>
        </b-form-group>
        <b-form-group label="Taxonomic Level">
          <select v-model="sublevel" class="form-control">
            <option v-for="subrank in sublevels" v-bind:key="subrank" :value="subrank">
              {{ subrank }}
            </option>
          </select>
        </b-form-group>
        <b-form-group label="Taxon groups per Bar">
          <select v-model="numberDisplayed" class="form-control">
            <option v-for="index in 18" v-bind:key="index" :value="index">
              {{ index }}
            </option>
          </select>
        </b-form-group>
        <b-form-group label="Number of Bars">
          <select v-model="barnumber" class="form-control">
            <option v-for="index in 20" v-bind:key="index" :value="index">
              {{ index }}
            </option>
          </select>
        </b-form-group>
        <div class="form-group mt-2" style="font-size: 1.6vmin;">
          <template>
            <b-form-group label="Fraction size" v-slot="{ ariaDescribedby }">
              <b-form-radio-group
                  :id="componentId+'radio-group-2'"
                  v-model="fraction"
                  :options="fractions"
                  :aria-describedby="ariaDescribedby"
                  name="fraction-options"
              ></b-form-radio-group>
            </b-form-group>
          </template>
        </div>
        <div>
          <b-form-checkbox
              :id="componentId+'advanced'"
              v-model="advanced"
              name="advanced_splitting"
              value="checked"
              unchecked-value="not_checked"
          >
            Advanced Splitting
          </b-form-checkbox>
        </div>
        <div class="form-group mt-2" style="font-size: 1.6vmin;" v-if="advanced === 'checked'">
          <template>
            <b-form-group label="Splitting : " v-slot="{ ariaDescribedby }">
              <b-form-radio-group
                  :id="componentId+'radio-group-advanced'"
                  v-model="splitBy"
                  :options="advancedSplittingOptions"
                  :aria-describedby="ariaDescribedby"
                  name="split-options"
              ></b-form-radio-group>
            </b-form-group>
          </template>
        </div>
      </div>
    </b-modal>
    <b-modal :id="componentId+'-legend'" title="Legend">
      HTML allowed
      <textarea class="col-12" v-model="legend" placeholder="add multiple lines"></textarea>

      <b-button v-b-toggle="'collapse'+ componentId" variant="primary">Show/Hide</b-button>
    </b-modal>
    <ExportDialog :componentId="componentId" :formattedData="formattedData" :plotData="plotData"
                  :exportFileName="exportFileName"
                  :dataset="dataset" :legend="legend"></ExportDialog>
    <div>
      <b-collapse v-model="visible" :id="'collapse'+componentId" class="">
        <b-card>
          <div v-html="legend">
          </div>

        </b-card>
      </b-collapse>
    </div>

  </div>
</template>


<script>
import axios from "axios"
import NormalizedBarChartWidget from "./NormalizedBarChartWidget";
import {mapActions} from "vuex"
import {ApiCall} from "../mixins/ApiMixin";
import ExportDialog from "./ExportDialog.vue";

export default {
  name: "NormalizedBarChart",
  props: ['panelId', 'componentId', 'triggerValue', 'settings'],
  mixins: [ApiCall],

  data() {
    return {
      dataset: null,
      advancedSplittingOptions: [
        {text: 'By Depth', value: 'depth'},
        {text: 'By Year', value: 'year'},
        {text: 'By Cluster', value: 'cluster'},
        {text: 'By Station', value: 'station'}
      ],
      advanced: "not_checked",
      splitBy: null,

      rank: null,
      searchPanelTaxon: null,
      visible: false,
      dateStart: null,
      dateEnd: null,
      legend: null,
      taxon: null,
      asv: null,
      taxons: {},
      asvs: {},
      formattedData: null,
      fractions: [],
      fraction: null,

      plotData: null,

      settingsHash: "",
      groupTypes: [
        {text: 'Sample', value: 'sample'},
        {text: 'Season', value: 'season'},
        {text: 'Year', value: 'year'},
        {text: 'Station', value: 'station'},
        {text: 'Depth', value: 'depth'}
      ],
      groupType: null,
      sublevels: [],
      dataTypes: [
        {text: 'Relative Abundance', value: 'relative_abundance'},
        {text: 'Richness', value: 'richness'}
      ],
      dataType: null,
      dataTypeText: null,
      sublevel: null,
      numberDisplayed: null,

      exportFileName: "mygod_normalized_barchart",
      apiCallsInProgress: 0,
      barnumber: null,
      page: null,
      plotName: '-barchart_plot_area'


    }
  },

  components: {
    NormalizedBarChartWidget,
    ExportDialog
  },

  created: function () {
    this.updateContents()
  },


  watch: {

    triggerValue() {
      this.updateContents()
    },
    fraction() {
      this.getPlotData()
    },
    groupType() {
      this.getPlotData()
    },
    sublevel() {
      this.getPlotData()
    },
    dataType() {
      this.dataTypeText = this.dataTypes.find(type => type.value === this.dataType).text
      this.getPlotData()
    },
    numberDisplayed() {
      this.getPlotData()
    },
    advanced() {
      if (this.advanced === 'not_checked') {
        this.splitBy = null
      }
    },
    splitBy() {
      this.getPlotData()
    },
    legend() {
      this.updateDashboardWidgetLegend({
        'componentId': this.componentId,
        'legend': this.legend
      })
    },
    plotData() {
      this.reformatNormalizedData()
    }
  },

  methods: {

    ...mapActions([
      'updateDashboardWidgetSettings',
      'cloneWidget',
      'updateDashboardWidgetLegend'
    ]),
    reformatNormalizedData() {
      this.formattedData = []
      for (let pool of this.plotData.data.values) {
        let group_name = pool['group']
        for (let values of pool['values']) {
          values['group'] = group_name
          this.formattedData.push(values)
        }
      }
    },

    updateContents() {
      let panel = this.$store.state.panels[this.panelId]

      let newPanelSettingsHash = panel.dataset + panel.rank + panel.taxon + panel.dateStart + panel.dateEnd
      if (newPanelSettingsHash === this.settingsPanelHash) {
        return
      }
      this.settingsPanelHash = newPanelSettingsHash
      this.plotData = null

      this.dataset = panel.dataset
      this.rank = panel.rank
      this.searchPanelTaxon = panel.taxon
      this.dateStart = panel.dateStart
      this.dateEnd = panel.dateEnd

      this.initializeGroupTypeDataType()
      this.initializeLegend()
      this.initializeSplitBy()
      this.initializeSublevels()
      this.initializeFractionSizes()
      this.getPlotData()


    },

    initializeGroupTypeDataType() {
      let me = this
      if (me.settings['restore']) {
        me.groupType = me.settings['groupType']
        me.dataType = me.settings['dataType']
        me.dataTypeText = me.dataTypes.find(type => type.value === me.dataType).text
        me.numberDisplayed = me.settings['numberDisplayed']
        me.page = me.settings['page']
        me.barnumber = me.settings['barnumber']
      } else {
        me.groupType = "sample"
        me.dataType = "relative_abundance"
        me.dataTypeText = me.dataTypes.find(type => type.value === me.dataType).text
        me.numberDisplayed = 5
        me.barnumber = 20
        me.page = 1
      }
    },

    initializeSublevels() {
      if (this.dataset) {
        let me = this
        me.apiCallsInProgress++
        axios
            .get(this.sanitizeApiCall(this.$store.state.apiRootPath,['taxonomy_subranks',
            this.dataset,this.rank,this.searchPanelTaxon]))
            .then(function (response) {
              if (response.data.length > 0) {
                me.sublevels = response.data;
                if (me.settings['restore']) {
                  me.sublevel = me.settings['sublevel']
                } else {
                  me.sublevel = me.sublevels[0]
                }
                me.apiCallsInProgress--
              }

            })
      }
    },

    getPlotData() {
      if (this.apiCallsInProgress > 0) {
        setTimeout(this.getPlotData, 2000)
        return
      }
      if (this.dataset && this.fraction && this.dateStart && this.dateEnd && this.searchPanelTaxon && this.sublevel && this.groupType && this.rank && this.dataType) {
        let newSettingsHash = this.dataset + this.searchPanelTaxon + this.fraction + this.dateStart + this.dateEnd + this.groupType + this.sublevel + this.rank + this.dataType + this.numberDisplayed + this.splitBy
        if (newSettingsHash === this.settingsHash) {
          return
        }
        this.settingsHash = newSettingsHash
        this.plotData = null

        this.updateDashboardWidgetSettings({
          'componentId': this.componentId,
          'settings': {
            'dataset': this.dataset,
            'taxon': this.taxon,
            'rank': this.rank,
            'fraction': this.fraction,
            'dateStart': this.dateStart,
            'dateEnd': this.dateEnd,
            'groupType': this.groupType,
            'sublevel': this.sublevel,
            'dataType': this.dataType,
            'numberDisplayed': this.numberDisplayed,
            'page': this.page,
            'barnumber': this.barnumber,
            "splitBy": this.splitBy,
            'legend': this.legend,
            'advanced': this.advanced
          }
        })

        let me = this
        axios
            .get(this.sanitizeApiCall(this.$store.state.apiRootPath,['grouped_abundances',
            this.dataset, this.rank, this.searchPanelTaxon,this.fraction, this.dateStart, this.dateEnd, this.groupType,
            this.sublevel, this.dataType, this.numberDisplayed, this.splitBy]))
            .then(function (response) {
              me.plotData = response.data
            })

      } else {
        console.debug("getPlotData() " + this.componentId + ": undefined parameters, no actual data  retrieval attempted.")
      }
    },

  }
}


</script>

<style scoped>

</style>
